import { Component } from '@theme/component';

/**
 * Horizontal product offers carousel with prev/next navigation.
 *
 * @extends {Component<{ track: HTMLElement }>}
 */
class ProductOffersComponent extends Component {
  /** @type {number} */
  #scrollAmount = 0;

  connectedCallback() {
    super.connectedCallback();
    this.#updateScrollAmount();
    window.addEventListener('resize', this.#handleResize);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('resize', this.#handleResize);
  }

  #handleResize = () => {
    this.#updateScrollAmount();
  };

  #updateScrollAmount() {
    const track = this.refs.track;
    if (!(track instanceof HTMLElement)) return;

    const card = track.querySelector('.product-offers__card');
    const cardWidth = card instanceof HTMLElement ? card.offsetWidth : track.clientWidth * 0.85;
    const gap = parseFloat(getComputedStyle(track.querySelector('.product-offers__cards') ?? track).gap) || 12;
    this.#scrollAmount = cardWidth + gap;
  }

  scrollPrev() {
    const track = this.refs.track;
    if (!(track instanceof HTMLElement)) return;

    track.scrollBy({ left: -this.#scrollAmount, behavior: 'smooth' });
  }

  scrollNext() {
    const track = this.refs.track;
    if (!(track instanceof HTMLElement)) return;

    track.scrollBy({ left: this.#scrollAmount, behavior: 'smooth' });
  }
}

if (!customElements.get('product-offers-component')) {
  customElements.define('product-offers-component', ProductOffersComponent);
}
